import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useApiMethods from "../../lib/useApiMethods";
import { QUOTATION_MERGED_URL, QUOTATION_MODULES_URL } from "../../constants/api";
import { MergedQuotationDocument } from "./QuotationDocument";
import { PrintToolbar } from "./QuotationPrint";

// Several quotations for one lead, printed as one proposal. The order of `ids`
// is the order of the document: the first quotation's project supplies the
// cover and the closing pages.
export default function QuotationMergedPrint() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { fetch } = useApiMethods();
  const ids = params.get("ids") || "";
  const [merged, setMerged]   = useState(null);
  const [error, setError]     = useState("");
  const [modules, setModules] = useState([]);
  const [editing, setEditing] = useState(false);
  const [docKey, setDocKey]   = useState(0);

  useEffect(() => {
    (async () => {
      const [r, m] = await Promise.all([
        fetch(QUOTATION_MERGED_URL, { ids }),
        fetch(QUOTATION_MODULES_URL),
      ]);
      if (r?.status === "success") setMerged(r.data);
      else setError(r?.message || "Could not load these quotations");
      if (m?.status === "success") setModules(m.data || []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);

  if (error) return <div className="p-6 text-sm text-red-600">{error}</div>;
  if (!merged) return <div className="p-6 text-sm text-gray-500">Loading…</div>;

  const firstId = merged.sections[0]?.quotation?.id;
  return (
    <div className="bg-gray-100 min-h-screen print:min-h-0 print:bg-white">
      <PrintToolbar
        title={`Merged proposal · ${merged.customer_name} · ${merged.summary.map(s => s.quote_number).join(" + ")}`}
        onBack={() => nav(firstId ? `/quotations/${firstId}` : "/quotations")}
        editing={editing} setEditing={setEditing}
        onReset={() => { setEditing(false); setDocKey(k => k + 1); }} />
      <MergedQuotationDocument key={docKey} merged={merged} modules={modules} editable={editing} />
    </div>
  );
}
